export default "__VITE_ASSET__CJyZ0V6B__"